import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CCUnlockCardAction, ResetCCLockCardAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES, MODIFY_FLOATING_PANE } from 'actions/floatingPanesActions'

const activateReducer = createFetchableReducer<null>()
const ACTIVATE_INITIAL_STATE = createEmptyFetchable<null>()
export const activateCardRequestReducer: Reducer<CreditCardAppState['activateCardRequest']> = (prevState = ACTIVATE_INITIAL_STATE, action) => {
  switch (action.type) {
    case CCUnlockCardAction.type: {
      return activateReducer(prevState, action)
    }

    case ResetCCLockCardAction.type:
    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case MODIFY_FLOATING_PANE: {
      const { errorsMap, ...prevCleanState } = prevState
      return {
        ...prevCleanState,
        errorCode: null,
      }
    }
  }

  return prevState
}


